import React from 'react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/painPoints';
export function PainPointsSection() {
  return <section className="bg-brand-sand px-4 py-20 md:py-28" data-id="element-117" data-mp="2htbopmh5dzgg">
      <Reveal className="mx-auto max-w-5xl text-center" data-id="element-118" data-mp="2wpknyo11gcsv">
        <h2 className="text-3xl font-black text-brand-slate md:text-4xl" data-id="element-119" data-mp="2wmyegiul7n80">
          Vous vous reconnaissez dans ces situations ?
        </h2>
        <p className="mt-4 text-brand-gray" data-id="element-120" data-mp="35p7n136ap6ir">
          Si l&apos;une de ces situations vous parle, Pilates Reformer Prêt™️ a été conçu pour vous.
        </p>
        <div className="mt-12 grid gap-4 sm:grid-cols-2" data-id="element-121" data-mp="30ojz4qdd55sr">
          {painPoints.map(({
          icon: PointIcon,
          text
        }) => <article key={text} className="flex items-center gap-4 rounded-2xl border border-brand-slate/[0.06] bg-white p-5 text-left shadow-sm" data-id="element-122" data-mp="3agfwu0bjetwg">
              <PointIcon className="h-6 w-6 shrink-0 text-brand-sageInk" aria-hidden="true" data-id="element-123" data-mp="3oduqjh8tpnu8" />
              <span className="text-sm font-semibold leading-snug" data-id="element-124" data-mp="3kcsqwzazv9rq">{text}</span>
            </article>)}
        </div>
        <p className="mt-12 font-serif text-2xl font-bold italic text-brand-terracottaInk" data-id="element-125" data-mp="ww3jf3fcazcq">
          Et ce n&apos;est qu&apos;une partie de ce que ce système résout.
        </p>
      </Reveal>
    </section>;
}